import { Component, inject } from '@angular/core';

import { OverlayService } from '@rpgc-ai/services/overlay/overlay.service';

/**
 * Универсальный компонент оверлея для всего приложения
 * Используется для модальных окон и сайдбаров
 */
@Component({
  selector: 'app-ui-overlay',
  template: `
    @if (isVisible()) {
      <div
        class="overlay fixed inset-0 z-20 bg-black/50 transition-opacity duration-300"
        [class.hide-background]="isHideBackground()"
        [class.opacity-0]="!isVisible()"
        [class.opacity-100]="isVisible()"
        [class.pointer-events-none]="!isVisible()"
        (click)="handleOverlayClick()"
      ></div>
    }
  `,
  styles: [
    `
      .overlay {
        backdrop-filter: blur(2px);
      }

      .hide-background{
        backdrop-filter: blur(4px);
        background-color: rgb(33 33 33 / 0.98);
      }
    `,
  ],
})
export class OverlayComponent {
  readonly #overlayService = inject(OverlayService);

  /**
   * Сигнал, указывающий, видим ли оверлей
   */
  isVisible = this.#overlayService.isOverlayVisible;
  isHideBackground = this.#overlayService.isBackgroundHidden;

  /**
   * Обработчик клика по оверлею
   */
  handleOverlayClick(): void {
    if (this.isVisible()) {
      // Предотвращаем пробрасывание клика на другие элементы
      setTimeout(() => {
        // Отложенный вызов для обработки событий DOM
        this.#overlayService.handleOverlayClick();
      }, 0);
    }
  }
}
